import { render, staticRenderFns } from "./ProductsListNew.vue?vue&type=template&id=f995a178&"
import script from "./ProductsListNew.vue?vue&type=script&lang=js&"
export * from "./ProductsListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports